import { useCallback, useMemo } from 'react';

import { optionify } from 'lib/helpers/utility';
import { usePracticeOwnerLocations } from 'lib/hooks/queries/practice/usePracticeOwnerLocations';

import Select from 'components/shared/Select/Select';

const LocationSelect = ({ organization, practiceId, selectedLocation, setSelectedLocation }) => {
  const { data } = usePracticeOwnerLocations({
    params: { organizationId: organization?.id, practiceId },
    dependencies: [organization?.id, practiceId],
    options: { enabled: Boolean(organization?.id && practiceId) }
  });

  const locationsOptions = useMemo(
    () => optionify(data?.locations || []),
    [data?.locations]
  );

  const handleChange = useCallback(
    (val) => setSelectedLocation(val),
    [setSelectedLocation]
  );

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-500 text-neutral-900">
        Location <span className="text-danger-500">*</span>
      </label>
      <Select
        onChange={handleChange}
        value={selectedLocation}
        placeholder="Select a location from which you want to import data from"
        options={locationsOptions}
      />
    </div>
  );
};

export default LocationSelect;
